(() => {
  const selectors = {
    journal: { grid: '.blog-posts-container', cards: '.blog-post-item', title: '.blog-post-card__title-link', details: '.blog-post-details', content: '.blog-post-card__content-text' },
    home: { grid: '.tm-home-blog__grid', cards: '.tm-home-blog__card', title: '.tm-home-blog__copy h3', details: null, content: '.tm-home-blog__copy p', link: '.tm-home-blog__read' },
  };

  const rowsFor = (cards) => {
    const rows = [];
    cards.forEach((card) => {
      const top = Math.round(card.getBoundingClientRect().top);
      let row = rows.find((candidate) => Math.abs(candidate.top - top) <= 2);
      if (!row) { row = { top, cards: [] }; rows.push(row); }
      row.cards.push(card);
    });
    return rows;
  };

  const reset = (cards, selector) => cards.forEach((card) => card.querySelectorAll(selector).forEach((element) => element.style.removeProperty('height')));

  const align = (grid, config) => {
    const cards = [...grid.querySelectorAll(`:scope > ${config.cards}`)];
    if (cards.length < 2) return;
    const targets = [config.title, config.details, config.content, config.link].filter(Boolean);
    targets.forEach((selector) => reset(cards, selector));
    rowsFor(cards).forEach(({ cards: rowCards }) => {
      if (rowCards.length < 2) return;
      targets.forEach((selector) => {
        const elements = rowCards.flatMap((card) => [...card.querySelectorAll(selector)]);
        const height = Math.max(...elements.map((element) => element.getBoundingClientRect().height));
        elements.forEach((element) => { element.style.height = `${height}px`; });
      });
    });
  };

  const observed = new WeakSet();
  let observer;
  const run = () => {
    [...document.querySelectorAll(selectors.journal.grid)].forEach((grid) => { align(grid, selectors.journal); if (!observed.has(grid)) { observer.observe(grid); observed.add(grid); } });
    [...document.querySelectorAll(selectors.home.grid)].forEach((grid) => { align(grid, selectors.home); if (!observed.has(grid)) { observer.observe(grid); observed.add(grid); } });
  };

  let frame;
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(run); };
  observer = new ResizeObserver(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true }); else schedule();
  window.addEventListener('resize', schedule, { passive: true });
  if (document.fonts?.ready) document.fonts.ready.then(schedule);
})();
